/**
 * 进屏 KYC 门禁(rbac 强制点 16/17)。未实名 → 渲染居中 gate 卡 + 「去实名认证」。
 * 跳 /kyc-verify 并带 from(实名成功后回本页续写)。发布/管理页在进屏用它包裹内容。
 */
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/auth';
import { isKycVerified } from '@/lib/identity';

export function KycGate({ prompt, children }: { prompt: string; children: React.ReactNode }) {
  const navigate = useNavigate();
  const location = useLocation();
  const identityState = useAuthStore((s) => s.identityState);

  if (isKycVerified(identityState)) {
    return <>{children}</>;
  }

  return (
    <div className="inner section">
      <div className="state">
        <div className="ic">🪪</div>
        <h2 className="h2 mb-3">先完成实名认证</h2>
        <p className="muted sm mb-6">{prompt}</p>
        <button
          type="button"
          className="btn btn-primary btn-lg"
          onClick={() =>
            navigate('/kyc-verify', {
              state: { from: location.pathname + location.search },
            })
          }
        >
          去实名认证
        </button>
      </div>
    </div>
  );
}
